// @noflow
import React from 'react';
import { Tel } from '@latitude/tel';
import { Text } from '@latitude/text';
import { FONT_WEIGHT, COLOR } from '@latitude/core/utils/constants';
import { formatAsCurrency } from '../../../utils';
import { PL_MINIMUM_AMOUNT, PL_MAXIMUM_AMOUNT } from '../../../utils/constants';

/* Purpose Error Message */
export const PURPOSE_ERROR_MESSAGE = 'Select a loan purpose';

/* Purpose Other Error Message */
export const PURPOSE_OTHER_ERROR_MESSAGE = 'Enter a loan purpose';

/* Loan Amount Min threshold Error Message */
export const AMOUNT_MIN_ERROR_MESSAGE = `Loan amount must be at least ${formatAsCurrency(
  PL_MINIMUM_AMOUNT
)}`;

/* Loan Amount Max threshold Error Message */
export const AMOUNT_MAX_ERROR_MESSAGE: React.ReactNode = (
  <Text color={COLOR.TEXT_ERROR} fontWeight={FONT_WEIGHT.NORMAL}>
    For loan amounts more than {formatAsCurrency(PL_MAXIMUM_AMOUNT)} please call
    us on <Tel color={COLOR.TEXT_ERROR} no="0800 422 898" /> Mon -Fri, 8:30am -
    6:30pm (NZST)
  </Text>
);
